import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { rem } from 'polished'

export const NameStyles = ({ theme }) => {
  const PackageCard = theme?.components?.PackageCard

  return css`
    .title {
      margin: 0;
      letter-spacing: 1px;
      text-transform: uppercase;

      color: ${`${
        PackageCard?.title?.color || PackageCard?.color || 'black'
      } !important`};

      font-weight: ${PackageCard?.title?.weight || 'bold'};
      font-family: ${PackageCard?.title?.fontFamily || 'inherit'};
      line-height: ${rem(theme?.fonts?.body.sm.lineHeight)};
      font-size: ${PackageCard?.title?.size ||
      rem(theme?.fonts?.body?.md?.size)};
      line-height: ${PackageCard?.title?.lineHeight ||
      rem(theme?.fonts?.body?.sm?.lineHeight)};
    }
  `
}

export const Name = styled.div(NameStyles)

export const DescriptionStyles = ({ theme }) => {
  const PackageCard = theme?.components?.PackageCard
  return css`
    .description {
      margin: 0;
      color: ${`${
        PackageCard?.title?.color || PackageCard?.color || 'black'
      } !important`};
    }
  `
}

export const Description = styled.div(DescriptionStyles)
